import React, { Suspense, useEffect } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useNavigate } from 'react-router-dom';
import { selectToken } from 'store/auth/selectors';
import Loader from 'assets/lottie/Loader/Loader';
const Recaptcha = ({ children, external }) => {
    const navigate = useNavigate();
    const token = selectToken();
    useEffect(() => { if (!external && !token)
        setTimeout(() => navigate('/login'), 100); }, [external, token]); // eslint-disable-line
    return (React.createElement(Suspense, { fallback: React.createElement(Loader, null) }, external ? (React.createElement(GoogleReCaptchaProvider, { reCaptchaKey: "6LfJRaIoAAAAAIyn0LVU-6i44LfN1STBcvqbb9kg" }, children)) : children));
};
export default Recaptcha;
